import { ChangeDetectionStrategy, Component, computed, input, type Type } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { ClientToolRenderPartComponent } from '../client-tool-render-part/client-tool-render-part.component';

@Component({
  selector: 'tellent-assistant-tool-call-part',
  imports: [ClientToolRenderPartComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.client-render]': 'isClientToolRender()' },
  template: `
    @if (isClientToolRender()) {
      <tellent-assistant-client-tool-render-part [component]="renderComponent()" [args]="args()" />
    } @else if (status() === 'running') {
      <span class="pill">
        <span class="spinner"></span>
        {{ 'tlc.tellent_assistant.tool_call.running_status' | translate: { name: name() } }}
      </span>
    } @else if (status() === 'done' && (durationMs() ?? 0) >= 1000) {
      <span class="pill">
        {{
          'tlc.tellent_assistant.tool_call.done_status'
            | translate: { duration: formatDuration(durationMs()) }
        }}
      </span>
    } @else if (status() === 'error') {
      <span class="pill error">
        <span>!</span>
        {{ 'tlc.tellent_assistant.tool_call.error_status' | translate }}
      </span>
    }
  `,
  styleUrl: './tool-call-part.component.less',
})
export class TellentAssistantToolCallPartComponent {
  protected readonly isClientToolRender = computed(() => !!this.renderComponent());

  public readonly name = input.required<string>();
  public readonly toolCallId = input.required<string>();
  public readonly args = input<unknown>();
  public readonly status = input.required<'running' | 'done' | 'error'>();
  public readonly durationMs = input<number | null>(null);
  public readonly renderComponent = input<Type<unknown> | undefined>(undefined);

  protected formatDuration(ms: number | null | undefined): string {
    if (ms == null) return '0s';
    const s = Math.max(1, Math.round(ms / 1000));
    return `${s}s`;
  }
}
